
export default function error_handler(error) {
    console.error(error);
}




// WEBPACK FOOTER //
// ./src/ErrorHandler.js